/**
 * FAQs Accordion
 * DSS - DeSight Shopify Theme
 * Enhances native details/summary accordion with smooth behavior
 */

import { $, $$, debounce } from '../utils/helpers.js';

class FAQsAccordion {
  constructor(container) {
    this.container = container;
    this.items = this.container ? Array.from(this.container.querySelectorAll('.dss-faqs__item')) : [];
    this.activeItem = null;
    
    if (!this.container || this.items.length === 0) return;
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.handleHashNavigation();
    this.checkOpenOnLoad();
  }

  bindEvents() {
    this.items.forEach(item => {
      const summary = item.querySelector('.dss-faqs__question');
      if (summary) {
        summary.addEventListener('click', (e) => this.handleItemClick(e, item));
      }
    });

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.contains?.(this.container)) {
        this.reinitialize();
      }
    });
  }

  handleItemClick(e, item) {
    const isOpen = item.hasAttribute('open');
    
    if (isOpen) {
      this.closeItem(item);
    } else {
      this.openItem(item);
    }
  }

  openItem(item) {
    if (this.activeItem && this.activeItem !== item) {
      this.closeItem(this.activeItem);
    }
    
    item.setAttribute('open', '');
    this.activeItem = item;
    
    item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  closeItem(item) {
    item.removeAttribute('open');
    if (this.activeItem === item) {
      this.activeItem = null;
    }
  }

  handleHashNavigation() {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      const targetItem = this.items.find(item => {
        const id = item.id.replace('Block-', '');
        return id === hash || item.querySelector(`[id="${hash}"]`);
      });
      
      if (targetItem) {
        setTimeout(() => {
          this.openItem(targetItem);
        }, 100);
      }
    }
  }

  checkOpenOnLoad() {
    const openItem = this.container.querySelector('.dss-faqs__item[open]');
    if (openItem) {
      this.activeItem = openItem;
    }
  }

  reinitialize() {
    this.items = this.container ? Array.from(this.container.querySelectorAll('.dss-faqs__item')) : [];
    this.activeItem = null;
    this.bindEvents();
    this.checkOpenOnLoad();
  }
}

function initFAQs() {
  const faqContainers = $$('.dss-faqs__list');
  
  faqContainers.forEach(container => {
    new FAQsAccordion(container);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFAQs);
} else {
  initFAQs();
}

document.addEventListener('shopify:section:load', (event) => {
  const faqContainers = event.target?.querySelectorAll?.('.dss-faqs__list');
  if (faqContainers) {
    faqContainers.forEach(container => {
      new FAQsAccordion(container);
    });
  }
});

export { FAQsAccordion, initFAQs };
